<!--
 * @Author: Latte
 * @Date: 2022-01-11 14:06:16
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-17 15:42:23
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\videoCourse\videoDetail\likeUsers.vue
-->
<template>
  <div>
    <!-- 内容 -->
    <el-table
      :data="videoLikeUserList"
      :header-cell-style="{ background: '#F5F7FA' }"
      style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column
        prop="videoLikerID"
        label="#"
        align="center"
        width="100"
      />
      <el-table-column prop="nickname" label="点赞用户" align="center" >
		  <template #default="scope">
			  <el-avatar :src="getImageUrl(scope.row.avatar)" :key="scope.row.avatar"></el-avatar>
			  <br />
			  {{scope.row.nickname}}
		  </template>
	  </el-table-column>
      <!-- <el-table-column prop="videoID" label="视频ID" align="center" /> -->
      <el-table-column label="点赞时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-show="totalCount > pageSize"
      background
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import { getVideoLikeUserList } from "@/api/videoDetail";
import {
	getCloudUrl
} from "@/utils/urlutil"
export default {
  name: "likeUsers",

  props: {
    videoID: {
      type: Number,
    },
  },

  data() {
    return {
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      videoLikeUserList: [], // 视频点赞用户列表
    };
  },

  activated() {
    this.getVideoLikeUserList();
  },

  deactivated() {},

  methods: {
	  getImageUrl(url){
		 return getCloudUrl(url) 
	  },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getVideoLikeUserList();
    },
    /**
     * 获取视频点赞用户列表
     */
    getVideoLikeUserList() {
      const params = {
        videoID: this.videoID,
        pageNumber: this.currentPage || 1,
        pageSize: this.pageSize || 10,
        keyWord: "",
        where: "",
      };
      getVideoLikeUserList(params).then((res) => {
        this.videoLikeUserList = res.data.rows;
        this.totalCount = res.data.total;
      });
    },
  },
};
</script> 


<style scoped>
</style>
